<template>
    <article class="download-card">
        <div class="download-card__header">
            <div class="download-card__icon" aria-hidden="true">
                <ui-icon icon="file-earmark-pdf" size="32"></ui-icon>
            </div>
        </div>

        <div class="download-card__body">
            <h3 class="download-card__title" v-if="document.title || document.type">{{ document.title || document.type }}</h3>

            <dl class="download-card__details">
                <div class="dt-dd" v-if="plantLocationDisplay">
                    <dt>Werk:</dt>
                    <dd>
                        {{ plantLocationDisplay }}
                    </dd>
                </div>

                <div class="dt-dd" v-if="document.number">
                    <dt>Nummer:</dt>
                    <dd>
                        {{ document.number }}
                    </dd>
                </div>

                <div class="dt-dd" v-if="document.validUntil">
                    <dt>Gültig bis:</dt>
                    <dd>
                        {{ document.validUntil }}
                    </dd>
                </div>
                <div class="dt-dd" v-if="document.material">
                    <dt>Material:</dt>
                    <dd>
                        {{ document.material }}
                    </dd>
                </div>
                <div class="dt-dd flex-column mt-2" v-if="document.enNormTerm">
                    <dt>EN Norm / Bezeichnung:</dt>
                    <dd>
                        {{ document.enNormTerm }}
                    </dd>
                </div>
            </dl>
            <div
                class="download-card__file-info"
                aria-label="Dateiformat und Größe"
                v-if="document.fileType && document.fileSize"
            >
                ({{ document.fileType }}, {{ document.fileSize }})
            </div>
        </div>

        <div class="download-card__footer">
            <a
                v-if="document.fileUrl"
                :href="document.fileUrl"
                :download="document.fileName"
                class="btn btn-c-primary"
                :aria-label="`${document.fileName} herunterladen (${document.fileType}, ${document.fileSize})`"
            >
                <span>Download</span>
                <ui-icon icon="download" size="16"></ui-icon>
            </a>
        </div>
    </article>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    document: {
        type: Object,
        required: true,
    },
});

// Handle plantLocation that can be either string or object
const plantLocationDisplay = computed(() => {
    const loc = props.document.plantLocation;
    if (!loc) return null;
    
    // If it's an object with display property
    if (typeof loc === 'object' && loc.display) {
        return loc.display;
    }
    
    // If it's an object with name/code
    if (typeof loc === 'object' && loc.name) {
        return loc.code ? `${loc.name} (${loc.code})` : loc.name;
    }
    
    // If it's a string
    if (typeof loc === 'string') {
        return loc;
    }
    
    return null;
});
</script>
